import React, { useEffect, useRef, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useChat } from "../../App"; // Adjust path based on your file structure
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import rocketImage from "../../image/rocket.png";
import bgImage from "../../image/ctaBg.png";

import PaymentPopup from "../../component/PaymentPopup";

import LoginPopup from "../../component/LoginPopup";
import MasterclassAuthModal from "../../component/MasterclassAuthModal";
import { getCourseImageUrl, formatCourseDuration } from "../helper/courseMedia";

import ReCAPTCHA from "react-google-recaptcha";

import {
  AcademicCapIcon,
  BriefcaseIcon,
  BuildingStorefrontIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";

import {
  ShoppingCartIcon,
  MagnifyingGlassIcon,
  CalendarDaysIcon,
  MegaphoneIcon,
  SparklesIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";

import {
  VideoButtonIcon,
  FormSubMissionButton,
  KingsterLogo,
  EnrolStar,
  EnrolStudents,
  EnrolLanguage,
  EnrolReviews,
  EnrolWishlist,
  CourseButtonArrow,
  CourseFacebook,
  CourseLinkedIn,
  CourseTwitter,
  GetInTouch,
  Wishlist,
  Duration,
  Live,
  Recorded,
} from "../../svg";
import FaqList from "../../component/FaqList";
import CurriculumDetails from "../../component/CurriculumDetails";
import Msme from "../../component/Msme";

import FooterComponent from "../../component/FooterComponent";
import Toastify from "../helper/Toastify";
import api from "../helper/Api";
import { getProfile } from "../redux/userSlice";
import { getCourseDetails, getReviews } from "../redux/courseSlice";
import { calculateActualPrice } from "../helper/Calculation";
import { useFormik } from "formik";
import * as yup from "yup";
import enrollCourseImage from "../../image/enrollCourse.jpg";
import certificateCourseImage from "../../image/certificate.jpg";
import { CircularProgress } from "@mui/material";
import HowToApply from "../../component/HowToApply";
import LearningMethod from "../../component/LearningMethod";

import {
  // AcademicCapIcon,
  ChartBarIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import SupportSection from "../../component/StudentSupport";

const CourseDetailsPage = () => {
  const { openChat } = useChat();

  const icons = [
    AcademicCapIcon, // For Aspiring E-Commerce Entrepreneurs
    BriefcaseIcon, // For Current E-Commerce Professionals
    BuildingStorefrontIcon, // For Brick-and-Mortar Business Owners
    BuildingOfficeIcon, // For MSMEs
  ];

  const outcomeIcons = [
    ShoppingCartIcon, // Build Ecommerce Store
    MagnifyingGlassIcon, // Digital Marketing
    GlobeAltIcon, // Global Selling

    ChartBarIcon, // Analytics
    AcademicCapIcon, // Certification
    WrenchScrewdriverIcon, // Hands on Projects

    CalendarDaysIcon, // Launch Business
    MegaphoneIcon, // Social Media

    BuildingStorefrontIcon, // Amazon / Flipkart

    SparklesIcon, // AI Tools
  ];

  const [pendingPaymentAction, setPendingPaymentAction] = useState(false);
  const [showMasterclassAuth, setShowMasterclassAuth] = useState(false);

  // Add state for captcha verification
  const [captchaVerified, setCaptchaVerified] = useState(true);
  const [captchaToken, setCaptchaToken] = useState("");

  // Add this with your other ref declarations
  const enquireFormRef = useRef(null);

  // Add state for custom price
  const [customPrice, setCustomPrice] = useState(null);
  const [isCustomLink, setIsCustomLink] = useState(false);
  const [loadingCustomPrice, setLoadingCustomPrice] = useState(false);

  // Get search params from URL
  const [searchParams] = useSearchParams();
  const customSlug = searchParams.get("custom");

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);

  // Add reCAPTCHA site key (get this from Google reCAPTCHA admin)
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleCaptchaChange = (token) => {
    setCaptchaVerified(!!token);
    setCaptchaToken(token);
  };

  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const icons2 = [
    <AcademicCapIcon className="w-12 h-12 text-[#1D83F8]" />,
    <ChartBarIcon className="w-12 h-12 text-[#1D83F8]" />,
    <GlobeAltIcon className="w-12 h-12 text-[#1D83F8]" />,
    <AcademicCapIcon className="w-12 h-12 text-[#1D83F8]" />,
    <ChartBarIcon className="w-12 h-12 text-[#1D83F8]" />,
    <GlobeAltIcon className="w-12 h-12 text-[#1D83F8]" />,
    <AcademicCapIcon className="w-12 h-12 text-[#1D83F8]" />,
    <ChartBarIcon className="w-12 h-12 text-[#1D83F8]" />,
    <GlobeAltIcon className="w-12 h-12 text-[#1D83F8]" />,
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [source, setSource] = useState("Website");
  const [affiliateId, setAffiliateId] = useState(null);
  const [affiliateSource, setAffiliateSource] = useState(null);
  const [loading, setLoading] = useState(false);

  // Add this scroll function with your other functions
  const scrollToEnquireForm = () => {
    if (enquireFormRef.current) {
      enquireFormRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    const fetchCustomPrice = async () => {
      if (!customSlug) {
        console.log("⏹️ No custom slug, skipping fetch");
        return;
      }

      console.log("🔄 Fetching custom price for slug:", customSlug);
      console.log("🌐 API Base URL:", api.api_url);
      console.log(
        "🔗 Full Endpoint:",
        `/student/course/custom-link/getcourse-by-slug/${customSlug}`,
      );

      setLoadingCustomPrice(true);

      try {
        const res = await api.getCustomCourseDetails(customSlug);
        console.log("✅ API Response:", res.data);

        if (res.data.success && res.data.customPrice !== undefined) {
          setCustomPrice(res.data.customPrice);
          setIsCustomLink(true);
          console.log("🎯 Custom price set:", res.data.customPrice);
        } else {
          console.log("❌ API success but no custom price data");
          console.log("📊 Response structure:", res.data);
          setIsCustomLink(false);
        }
      } catch (err) {
        console.error("❌ Error fetching custom price:", err);
        console.error("📊 Error status:", err.response?.status);
        console.error("📝 Error data:", err.response?.data);
        console.error("🔧 Error config:", err.config);
        setIsCustomLink(false);
      } finally {
        setLoadingCustomPrice(false);
      }
    };

    fetchCustomPrice();
  }, [customSlug]);

  // Memoized URL search parameters to prevent unnecessary re-parsing
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const faqSectionRef = useRef(null);

  // Function to scroll to FAQ section
  const scrollToFaq = () => {
    console.log("Scroll to FAQ called");
    if (faqSectionRef.current) {
      console.log("Scrolling to FAQ section");
      faqSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.log("FAQ section ref is null");
    }
  };

  const { id } = useParams();
  const { courseDetailsData } = useSelector((state) => state.courses);

  const ratingScore = courseDetailsData?.overallRating;
  const curriculum = courseDetailsData?.course?.modules;
  const starRatings = courseDetailsData?.starRatings;
  const { reviewData } = useSelector((state) => state.courses);
  const userProfile = useSelector((state) => state.user);

  const getUserProfile = userProfile?.user?.courses;
  const purchasedCourseId = getUserProfile?.find((item) => item === id);

  const fullStars = Math.floor(ratingScore); // Get the number of full stars
  const fractionalPart = ratingScore - fullStars; // Get the decimal part
  const halfStar = fractionalPart >= 0.25 && fractionalPart < 0.75; // Check for significant fractional part
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0); // Remaining stars

  const [isPlaying, setIsPlaying] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rating, setRating] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isHighlighted, setIsHighlighted] = useState(false);

  const isAuthenticated = !!localStorage.getItem("token");

  useEffect(() => {
    const addCourseCount = async () => {
      try {
        const { countCourse, status } = await api.getCourseCount(id);
      } catch (error) {
        console.error("Error fetching course count", error);
      }
    };

    addCourseCount();
  }, [id]);

  //Effects

  const useLazyBackground = (imageUrl) => {
    const [shouldLoad, setShouldLoad] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      if (!imageUrl || shouldLoad) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setShouldLoad(true);
            observer.unobserve(entry.target);
          }
        },
        { rootMargin: "100px" }, // Start loading 100px before it enters viewport
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) observer.unobserve(ref.current);
      };
    }, [imageUrl, shouldLoad]);

    return { ref, shouldLoad };
  };

  // Function to handle query parameters
  useEffect(() => {
    const utmSource = queryParams.get("utm_source")?.toLowerCase(); // Normalize case
    const utmAffiliate = queryParams.get("utm_affiliate");
    const utmAffiliateSource = queryParams.get("utm_affiliate_source");

    if (utmSource === "affiliate" && utmAffiliate) {
      // Case: Affiliate link with additional tracking details
      setSource("Affiliate");
      setAffiliateId(utmAffiliate);
      setAffiliateSource(utmAffiliateSource || "Unknown"); // Default to "Unknown" if missing
    } else if (utmSource) {
      // Case: Standard UTM source like Instagram, Facebook, etc.
      setSource(utmSource.charAt(0).toUpperCase() + utmSource.slice(1));
    } else {
      // Default case (direct website visit)
      setSource("Website");
    }
  }, [queryParams]);

  useEffect(() => {
    dispatch(getCourseDetails(id));
  }, [dispatch, id]);

  useEffect(() => {
    let data = {
      rating,
      page: currentPage,
    };
    // Convert data to query string
    const queryString = new URLSearchParams(data).toString();

    // Combine ID and query string in the URL
    const url = `${id}?${queryString}`;
    dispatch(getReviews(url));
  }, [dispatch, rating, id, currentPage]);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  // schema -----------
  const schema = yup.object().shape({
    email: yup
      .string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter valid email",
      )
      .required("Please enter valid email"),
    name: yup.string().required("Name is required"),
    lastName: yup.string().notRequired(),
    primaryNumber: yup.string().required("Number is required"),
    message: yup.string().required("Description is required"),
    address: yup.string().required("Address is required"),
    acceptedTerms: yup
      .boolean()
      .oneOf([true], "Please accept Terms of Use and Privacy Policy"),
  });

  const { errors, values, handleChange, handleSubmit, touched, resetForm } =
    useFormik({
      initialValues: {
        name: "",
        lastName: "",
        email: "",
        primaryNumber: "",
        message: "",
        address: "",
        source: source,
        affiliateId: affiliateId || "",
        affiliateSource: affiliateSource || "",
        courseId: `${id}`,
        leadType: "COURSE", // Add leadType
        acceptedTerms: false,
      },
      validationSchema: schema,
      onSubmit: (values) => {
        handleSubject(values);
        resetForm();
      },
    });

  // Update your form submission handler
  const handleSubject = async (values) => {
    try {
      // Verify captcha first
      if (!captchaVerified) {
        Toastify.error("Please complete the CAPTCHA verification");
        return;
      }

      if (!values.acceptedTerms) {
        Toastify.error("Please accept Terms of Use and Privacy Policy");
        return;
      }

      setLoading(true);
      const payload = {
        ...values,
        source,
        captchaToken, // Include the captcha token
        ...(source === "Affiliate" && { affiliateId, affiliateSource }),
        leadType: "COURSE", // Ensure leadType is set
        courseId: id, // Use courseId
      };

      const { data, status } = await api.addLead(payload);

      if (status === 200) {
        Toastify.success("Lead is created successfully");
        // Reset captcha after successful submission
        if (window.grecaptcha) {
          window.grecaptcha.reset();
        }
        setCaptchaVerified(false);
        setCaptchaToken("");
      } else {
        Toastify.error(data.message);
      }
    } catch (error) {
      console.log("Error fetching", error);
      Toastify.error(error?.response?.data?.message || "Internal server error");
    } finally {
      setLoading(false);
    }
  };

  // Function to format webinar date and time for display
  const formatWebinarDateTime = (date, time) => {
    if (!date || !time) return "Date to be announced";

    // Combine date and time into a single Date object
    const combinedDate = new Date(`${date?.split("T")[0]}T${time}`);

    // Format the date part
    const formattedDate = combinedDate.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short", // e.g., Jan
      year: "numeric",
    });

    // Format the time part
    const formattedTime = combinedDate.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM
    });

    return `${formattedDate} @ ${formattedTime}`;
  };

  const AddCourseToWishList = async () => {
    const body = new FormData();
    body.set("courseId", id);
    try {
      const { data, status, message } = await api.addCourseToWishlist(body);

      if (status === 200) {
        Toastify.success(data.data);
        setIsHighlighted(true);
      } else {
        Toastify.error(message);
      }
    } catch (error) {
      console.error("Error fetching course count", error);
    }
  };

  // Calculate the price to display
  const displayPrice = useMemo(() => {
    if (isCustomLink && customPrice !== null) {
      return customPrice;
    }
    return courseDetailsData?.course?.price || 0;
  }, [isCustomLink, customPrice, courseDetailsData]);

  // Calculate price with GST
  const priceWithGst = useMemo(() => {
    const price = parseFloat(displayPrice) || 0;
    return price + price * 0.18; // 18% GST
  }, [displayPrice]);

  const programOriginalPrice = courseDetailsData?.course?.price || 0;
  const formatIndianPrice = (value) =>
    Math.round(Number(value) || 0).toLocaleString("en-IN");
  const enrollLogo =
    courseDetailsData?.course?.courseEntrollLogo?.[0] ||
    courseDetailsData?.course?.courseEntrollLogo;
  const hasEnrollTrailer = Boolean(
    courseDetailsData?.course?.trailer?.[0]?.url,
  );

  const goToMasterclassPage = () => {
    setShowMasterclassAuth(false);
    navigate(`/courses/Courses/CourseDetails/Masterclass/${id}`);
  };

  const handleWatchMasterclass = () => {
    const trailerUrl = courseDetailsData?.course?.trailer?.[0]?.url;
    if (!trailerUrl) {
      Toastify.warning("Masterclass video is not available yet");
      return;
    }
    if (localStorage.getItem("token")) {
      goToMasterclassPage();
    } else {
      setShowMasterclassAuth(true);
    }
  };

  const infoData = [
    {
      title: `${courseDetailsData?.course?.modules.length} Modules`,
      description: "Learn at your own pace",
    },
    {
      title: `${courseDetailsData?.course?.duration?.value} ${courseDetailsData?.course?.duration?.unit}`,
      description: courseDetailsData?.course?.scheduledTime?.value
        ? `at ${courseDetailsData?.course?.scheduledTime?.value || ""} ${courseDetailsData?.course?.scheduledTime?.unit || ""
        }`
        : "",
    },
    {
      title: courseDetailsData?.course?.courseLevel,
      description: "Recommended experience",
    },
    { title: "Flexible schedule", description: "Learn at your own pace" },
  ];

  const keys = [
    "MSMEs & Startups",
    "Business Owners",
    "Entrepreneurs",
    "Students",
    "Working Professionals",
  ];

  const mainImageUrl = getCourseImageUrl(courseDetailsData?.course?.courseBanner);
  const { ref, shouldLoad } = useLazyBackground(mainImageUrl);

  return (
    <div>
      {showLoginPopup && (
        <LoginPopup
          isOpen={showLoginPopup}
          onClose={() => {
            setShowLoginPopup(false);
            setPendingPaymentAction(false);
          }}
          onSuccess={() => {
            if (pendingPaymentAction) {
              setShowPaymentPopup(true);
              setPendingPaymentAction(false);
            }
          }}
        />
      )}

      {showMasterclassAuth && (
        <MasterclassAuthModal
          isOpen={showMasterclassAuth}
          onClose={() => setShowMasterclassAuth(false)}
          onSuccess={goToMasterclassPage}
          courseId={id}
          source={source}
          courseTitle={courseDetailsData?.course?.title}
          thumbnail={getCourseImageUrl(courseDetailsData?.course?.thumbnail)}
          durationLabel={
            courseDetailsData?.course?.duration?.value
              ? formatCourseDuration(courseDetailsData.course.duration)
              : "20 Mins"
          }
        />
      )}

      {showPaymentPopup && (
        <PaymentPopup
          courseDetails={{
            ...courseDetailsData?.course,
            price: isCustomLink
              ? customPrice
              : courseDetailsData?.course?.price,
          }}
          onClose={() => {
            setShowPaymentPopup(false);
            setPendingPaymentAction(false); // Reset pending action
          }}
          onProceedToPayment={() => {
            // This will be called when user clicks "Proceed to Payment"
            if (!isAuthenticated) {
              setShowPaymentPopup(false);
              setShowLoginPopup(true);
              setPendingPaymentAction(true);
            }
            // If authenticated, payment will proceed directly in PaymentPopup
          }}
          isAuthenticated={isAuthenticated} // Pass auth status
        />
      )}

      <div
        className={`flex flex-col gap-5 font-figtree text-gray-800${hasEnrollTrailer ? " pb-24 lg:pb-0" : ""
          }`}
      >
        <div className="flex justify-center w-full px-4 text-sm md:text-lg font-medium leading-6 md:leading-7 tracking-tighter text-left underline-offset-auto underline-decoration-skip-ink-none break-words">
          Home / Courses /&nbsp;
          <span className="text-blue-500 break-words">
            {courseDetailsData?.course?.title}
          </span>
        </div>
        {/* ------------------------------------------------------------------ */}
        <div className="px-4 sm:px-6 lg:px-16 max-w-[1500px] w-full mx-auto">
          <div
            ref={ref}
            className="
      relative
      w-full
      min-h-0
      h-auto
      sm:h-[550px]
      md:h-[650px]
      lg:h-[700px]
      rounded-2xl
      overflow-hidden
      bg-cover
      bg-center
    "
            style={{
              backgroundImage: shouldLoad ? `url(${mainImageUrl})` : "none",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* Live / Recorded Badge */}
            {/* <div className="absolute top-4 right-4 sm:top-[32px] sm:right-[32px] z-20">
              <div
                className={`
          w-[130px]
          sm:w-[139px]
          h-[40px]
          sm:h-[31px]
          rounded-[8px]
          flex
          items-center
          justify-center
          ${courseDetailsData?.course?.courseType === "LIVESTREAM"
                    ? "bg-[#FF4A00]"
                    : "bg-[#008000]"
                  }
        `}
              >
                <span
                  className="
            font-[Figtree]
            font-medium
            text-[11px]
            sm:text-[14px]
            leading-[150%]
            tracking-[0.02em]
            text-center
            text-white
          "
                >
                  {courseDetailsData?.course?.courseType === "LIVESTREAM"
                    ? "● Live Class"
                    : "● Recorded Class"}
                </span>
              </div>
            </div> */}

            {/* Center Content */}
            <div className="
      relative
      z-20
      flex
      flex-col
      items-center
      justify-start
      sm:absolute
      sm:inset-0
      sm:justify-center
      pt-16
      sm:pt-0
      pb-6
      sm:pb-24
      md:pb-28
      text-center
      px-4
      sm:px-5
    ">
              {/* Title */}
              <h1
                className="
          font-bebas
          font-normal
          text-white
          text-[28px]
          sm:text-[64px]
          md:text-[80px]
          lg:text-[96px]
          leading-[110%]
          sm:leading-[90px]
          tracking-[0.02em]
          uppercase
          max-w-[92%]
          sm:max-w-[70%]
          lg:max-w-[55%]
          drop-shadow-lg
        "
              >
                {courseDetailsData?.course?.title}
              </h1>

              {/* Start Your Online Business In + Duration */}
              <div
                className="
          mt-4
          sm:mt-8
          md:mt-10
          flex
          flex-wrap
          items-center
          justify-center
          gap-3
          max-w-[92%]
          sm:max-w-[95%]
        "
              >
                <span
                  className="
            font-bebas
            font-normal
            text-white
            text-[18px]
            sm:text-[36px]
            md:text-[42px]
            lg:text-[48px]
            leading-none
            tracking-[0.01em]
            uppercase
            w-full
            sm:w-auto
          "
                >
                  Start Your Online Business In
                </span>

                <span
                  className="
            bg-white
            rounded-[8px]
            px-3
            sm:px-4
            md:px-1
            py-1
            sm:py-2
            shadow-lg
            whitespace-nowrap
            font-bebas
            font-normal
            text-[#06085E]
            text-[22px]
            sm:text-[36px]
            md:text-[42px]
            lg:text-[48px]
            leading-none
            tracking-[0.01em]
          "
                >
                  {courseDetailsData?.course?.duration?.value}{" "}
                  {courseDetailsData?.course?.duration?.unit}
                </span>
              </div>

              {/* Subtitle */}
              <div
                className="
          mt-4
          sm:mt-5
          max-w-[92%]
          sm:max-w-[700px]
          font-[Figtree]
          font-medium
          text-[13px]
          sm:text-[18px]
          md:text-[22px]
          leading-[140%]
          text-white
        "
              >
                {courseDetailsData?.course?.subtitle}
              </div>

              {/* Buttons */}
              <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-6 mt-5 sm:mt-10">
                {courseDetailsData?.course?.trailer &&
                  courseDetailsData?.course?.trailer[0]?.url && (
                    <div className="relative inline-flex justify-center p-2.5 sm:p-3 border-2 border-dashed border-white/70 rounded-md mb-2 sm:mb-0">
                      <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />

                      <button
                        type="button"
                        className="flex items-center justify-center gap-2 sm:gap-4 px-4 sm:px-8 py-3 sm:py-4 bg-[#FC3602] rounded-[8px] cursor-pointer hover:bg-[#E54E1A] transition-colors"
                        onClick={handleWatchMasterclass}
                      >
                        <img
                          className="w-5 h-5 sm:w-7 sm:h-7 shrink-0"
                          src="/assets/icons/play.svg"
                          alt=""
                        />
                        <span className="text-white font-bold uppercase text-[13px] sm:text-[17px] leading-tight">
                          Watch Free Masterclass
                        </span>
                      </button>

                      <span className="absolute -right-5 -bottom-6 sm:-right-7 sm:-bottom-8">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden
                        >
                          <path
                            d="M3 2L21 10L13 13L10 21L3 2Z"
                            fill="#FC3602"
                            stroke="#FC3602"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  )}

                {purchasedCourseId ? (
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 sm:gap-4 px-6 sm:px-8 py-3 sm:py-4 bg-transparent rounded-lg font-semibold text-white text-[14px] sm:text-[17px] border border-white hover:bg-white/10 transition-colors"
                    onClick={() =>
                      navigate(
                        `/courses/Courses/CourseDetails/CoursesVideos/${id}`
                      )
                    }
                  >
                    <img
                      className="w-5 h-5 sm:w-7 sm:h-7 shrink-0"
                      src="/assets/icons/enroll.svg"
                      alt=""
                    />
                    <span>Go to Course</span>
                  </button>
                ) : (
                  <button
                    type="button"
                    className="flex items-center justify-center gap-2 sm:gap-4 px-6 sm:px-8 py-3 sm:py-4 bg-transparent rounded-lg font-semibold text-white text-[14px] sm:text-[17px] border border-white hover:bg-white/10 transition-colors"
                    onClick={() => {
                      setShowPaymentPopup(true);
                      if (!isAuthenticated) {
                        setPendingPaymentAction(true);
                      }
                    }}
                  >
                    <img
                      className="w-5 h-5 sm:w-7 sm:h-7 shrink-0"
                      src="/assets/icons/enroll.svg"
                      alt=""
                    />
                    <span>Enroll Now</span>
                  </button>
                )}
              </div>

              {/* Mobile tags: in-flow so they never cover buttons */}
              <div className="mt-8 flex flex-wrap justify-center gap-2 px-1 sm:hidden">
                {courseDetailsData?.course?.bestSuitFor?.map((item, index) => (
                  <div
                    key={index}
                    className="px-4 py-2 rounded-full bg-black/70 border-2 border-gray-500 text-white font-[Figtree] text-[12px] whitespace-nowrap backdrop-blur-sm"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop/tablet tags */}
            <div
              className="
        absolute
        bottom-3
        sm:bottom-6
        left-1/2
        -translate-x-1/2
        z-10
        hidden
        sm:flex
        flex-wrap
        justify-center
        gap-2
        sm:gap-4
        w-full
        px-2
        sm:px-5
        pointer-events-none
      "
            >
              {courseDetailsData?.course?.bestSuitFor?.map((item, index) => (
                <div
                  key={index}
                  className="
            px-4
            sm:px-6
            py-2
            sm:py-3
            rounded-full
            bg-black/70
            border-2 border-gray-500
            text-white
            font-[Figtree]
            text-[12px]
            sm:text-sm
            whitespace-nowrap
            backdrop-blur-sm
          "
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Key Takeaways */}
        <div className="py-6 px-4">
          <h2
            className="
    font-[Figtree]
    font-semibold

    text-[34px]
    sm:text-[42px]
    lg:text-[55px]

    leading-[150%]

    tracking-[-0.03em]

    text-center

    text-[#06085E]
  "
          >
            Key Learning Outcomes
          </h2>

          <div
            className="
    mt-12

    max-w-6xl
    mx-auto

    grid

    grid-cols-1
    md:grid-cols-2
    lg:grid-cols-3

    gap-x-10
    gap-y-8
  "
          >
            {courseDetailsData?.course?.keyTakeAways?.map((item, index) => {
              const Icon = outcomeIcons[index % outcomeIcons.length];

              return (
                <div key={index} className="flex items-start gap-4">
                  <Icon
                    className="
            w-6
            h-6

            text-[#F15A24]

            flex-shrink-0

            mt-1
          "
                  />

                  <p
                    className="
            font-[Figtree]

            font-medium

            text-[18px]

            leading-[150%]

            text-[#12175B]
          "
                  >
                    {item}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Course Details */}
        <div className="flex flex-col items-center px-4 sm:px-6 lg:px-10 max-w-[1400px] w-full mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 w-full items-start">
            {/* Left Section - Course Details */}
            <div className="w-full lg:col-span-7">
              <div
                className="
    pb-6

    font-[Figtree]
    font-semibold

    text-[34px]
    sm:text-[42px]
    lg:text-[55px]

    leading-[150%]

    tracking-[-0.03em]

    text-center
    lg:text-left

    text-[#06085E]
  "
              >
                Course Details
              </div>

              {/* Intro Section — render dashboard Course Overview HTML as-is */}
              <div className="bg-[#F6F9FE] p-5 rounded-2xl mb-6">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      courseDetailsData?.course?.overview?.split("<ul>")[0] ||
                      "",
                  }}
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 w-full">
                {courseDetailsData?.course?.overview
                  ?.match(/<li[\s\S]*?<\/li>/g)
                  ?.map((item, index) => {
                    const Icon = icons[index % icons.length];

                    const titleMatch = item.match(
                      /<strong[^>]*>(.*?)<\/strong>/i,
                    );
                    const title = titleMatch
                      ? titleMatch[1].replace(/:$/, "")
                      : "";

                    const description = item
                      .replace(/<li[^>]*>|<\/li>/g, "")
                      .replace(/<strong[^>]*>.*?<\/strong>/i, "")
                      .replace(/<[^>]+>/g, "")
                      .trim();

                    return (
                      <div
                        key={index}
                        className="bg-white shadow-md rounded-2xl p-4 sm:p-6 border border-gray-200 flex flex-col items-start"
                      >
                        {/* Icon */}
                        <Icon className="w-8 h-8 text-[#1D83F8] mb-3" />

                        {/* Title */}
                        <h3 className="font-[Figtree] font-semibold text-[18px] leading-[140%] tracking-[0] text-[#1E1E1E]">
                          {title}
                        </h3>

                        {/* Description */}
                        <p className="font-[Figtree] font-normal text-[16px] leading-[134%] tracking-[0] text-[#1E1E1E] mt-2">
                          {description}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>

            {/* Right Section - Enquiry Form */}
            <div
              id="enquire-now-form"
              ref={enquireFormRef}
              className="w-full lg:col-span-5 p-4 sm:p-6 bg-white rounded-2xl shadow-[2px_1px_44px_4px_rgba(0,0,0,0.09)] self-start"
            >
              <h1 className="font-[Figtree] font-semibold text-[24px] leading-[150%] tracking-[-0.04em] text-black mb-6 border-b-2 border-[#1D83F8] pb-3 -mx-4 sm:-mx-6 px-4 sm:px-6">
                Enquire Now
              </h1>

              <form className="flex flex-col gap-6" onSubmit={handleSubmit}>
                {/* First & Last Name */}
                <div className="flex flex-col sm:flex-row gap-5 p-3">
                  <div className="flex-1 flex flex-col">
                    <label
                      htmlFor="firstName"
                      className="text-gray-800 font-medium mb-1"
                    >
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      value={values.name}
                      name="name"
                      onChange={handleChange}
                      placeholder=""
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    />
                    {/* Add error message */}
                    {errors.name && touched.name && (
                      <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                    )}
                  </div>

                  <div className="flex-1 flex flex-col">
                    <label
                      htmlFor="lastName"
                      className="text-gray-800 font-medium mb-1"
                    >
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      value={values.lastName}
                      name="lastName"
                      onChange={handleChange}
                      placeholder=""
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    />
                    {/* Add error message */}
                    {errors.lastName && touched.lastName && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.lastName}
                      </p>
                    )}
                  </div>
                </div>

                {/* Email & Phone */}
                <div className="flex flex-col sm:flex-row gap-5 p-3">
                  <div className="flex-1 flex flex-col">
                    <label
                      htmlFor="email"
                      className="text-gray-800 font-medium mb-1"
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={values.email}
                      name="email"
                      onChange={handleChange}
                      placeholder=""
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    />
                    {/* Add error message */}
                    {errors.email && touched.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                {/* Email & Phone */}
                <div className="flex flex-col sm:flex-row gap-5 p-3">
                  <div className="flex-1 flex flex-col">
                    <label
                      htmlFor="phone"
                      className="text-gray-800 font-medium mb-1"
                    >
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="phone"
                      value={values.primaryNumber}
                      name="primaryNumber"
                      onChange={handleChange}
                      placeholder=""
                      className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                    />
                    {/* Add error message */}
                    {errors.primaryNumber && touched.primaryNumber && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.primaryNumber}
                      </p>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div className="flex flex-col p-3">
                  <label
                    htmlFor="address"
                    className="text-gray-800 font-medium mb-1"
                  >
                    Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="address"
                    value={values.address}
                    name="address"
                    onChange={handleChange}
                    placeholder=""
                    className="w-full h-12 px-4 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                  />
                  {/* Add error message */}
                  {errors.address && touched.address && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.address}
                    </p>
                  )}
                </div>

                {/* Message */}
                <div className="flex flex-col p-3">
                  <label
                    htmlFor="message"
                    className="text-gray-800 font-medium mb-1"
                  >
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    value={values.message}
                    name="message"
                    onChange={handleChange}
                    placeholder=""
                    className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 h-24"
                  ></textarea>
                  {/* Add error message */}
                  {errors.message && touched.message && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.message}
                    </p>
                  )}
                </div>

                {/* Terms & Submit */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-3 ">
                  <label className="flex items-center gap-2 text-gray-600 font-medium">
                    <input
                      type="checkbox"
                      name="acceptedTerms"
                      checked={values.acceptedTerms}
                      onChange={handleChange}
                      className="w-5 h-5 sm:w-6 sm:h-6 bg-gray-500 font-[Figtree]"
                    />
                    I agree with Terms of Use and Privacy Policy
                  </label>
                  {errors.acceptedTerms && touched.acceptedTerms && (
                    <p className="text-red-500 text-xs mt-1 px-3">
                      {errors.acceptedTerms}
                    </p>
                  )}
                </div>

                {/* Add reCAPTCHA here */}
                <div className="px-3">
                  <ReCAPTCHA
                    sitekey={"6LeKca0rAAAAAEloRJKpYzxi2UB-wOPVXl5fYGKz"}
                    onChange={handleCaptchaChange}
                  />
                </div>
                <button
                  type="submit"
                  className="mb-12 m-auto flex items-center justify-center gap-3 text-white px-6 py-4 rounded-full w-auto min-w-[170px] h-[70px] border border-white/20 transition text-sm font-semibold bg-gradient-to-r from-[#1D83F8] to-[#114D92] hover:from-[#2a8ff9] hover:to-[#1a5cb3] shadow-md hover:shadow-lg"
                  disabled={loading || !captchaVerified || !values.acceptedTerms}
                  style={{
                    background: "linear-gradient(94.44deg, #1D83F8 1.62%, #114D92 78.57%)",
                  }}
                >
                  {loading ? (
                    <CircularProgress size={40} color="white" thickness={5} />
                  ) : (
                    <>
                      <img
                        src="/assets/icons/enroll.svg"
                        alt=""
                        className="w-12 h-12 object-contain"
                      />

                      <span className="text-base font-semibold">
                        Send Your Message
                      </span>
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* __________________________________________- */}

        <div className="flex flex-col items-center px-4 sm:px-6 lg:px-10 py-10 max-w-[1400px] w-full mx-auto">
          <h2
            className="
      font-[Figtree]
      font-semibold
      text-[34px]
      sm:text-[42px]
      lg:text-[55px]
      leading-[150%]
      tracking-[-0.03em]
      text-center
      text-[#06085E]
      mb-12
    "
          >
            Key Program Highlights
          </h2>

          <div className="w-full flex flex-wrap justify-center gap-8">
            {courseDetailsData?.course?.KeyProgramHighlights?.map(
              (item, index) => (
                <div
                  key={index}
                  className="
            bg-[#F9FAFB]
            border-[1.5px]
            border-dashed
            border-[#06085E]
            rounded-2xl
            px-6
            sm:px-8
            py-8
            min-h-[200px]
            flex
            items-center
            justify-between
            gap-6
            transition-all
            duration-300
            hover:border-[#1D83F8]
            w-full
            max-w-[600px]
            lg:w-[calc(50%-1rem)]
            lg:max-w-[calc(50%-1rem)]
          "
                >
                  {/* Left Content */}
                  <div className="flex-1">
                    <h3
                      className="
                font-[Figtree]
                font-semibold
                text-[#06085E]
                text-[28px]
                sm:text-[34px]
                leading-[120%]
                tracking-[-0.03em]
              "
                    >
                      {item?.title}
                    </h3>

                    {item?.subTitle && (
                      <p
                        className="
                  mt-4
                  font-[Figtree]
                  font-medium
                  text-[16px]
                  leading-[150%]
                  text-[#4B5563]
                "
                      >
                        {item?.subTitle}
                      </p>
                    )}
                  </div>

                  {/* Right Image */}
                  {item?.img?.[0] && (
                    <div
                      className="
                w-[100px]
                h-[100px]
                sm:w-[100px]
                sm:h-[100px]
                flex-shrink-0
                flex
                items-center
                justify-center
              "
                    >
                      <img
                        src={item.img[0]}
                        alt={item?.title}
                        className="
                  w-full
                  h-full
                  object-contain
                "
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    </div>
                  )}
                </div>
              ),
            )}
          </div>
        </div>
        {/* Curriculum */}
        {/* <div className="lg:px-[60px] px-[20px] max-w-[1500px] w-full mx-auto">
          <CurriculumDetails
            curriculum={curriculum}
            courseDetailsData={courseDetailsData}
          />
        </div> */}

        {/* Curriculum */}
        <div className="lg:px-[60px] px-[20px] max-w-[1500px] w-full mx-auto">
          <Msme courseDetailsData={courseDetailsData} />
        </div>

        {/* ------------------------------------------------------------------- */}
        {/* Enroll Course */}
        <div className="w-full mb-16">
          <div
            className="relative overflow-hidden"
            style={{
              backgroundImage: `url(${courseDetailsData?.course?.courseEntrollBanner?.[0] ||
                enrollCourseImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* No overlays or masks - removed completely */}

            {/* Removed: Dark Overlay, Gradient, Vertical Lines */}

            <div className="relative z-10 px-4 sm:px-6 md:px-8 lg:px-16 py-8 sm:py-10 md:py-12 lg:py-14 text-white">
              {/* DESCRIPTION */}
              <p className="max-w-[1400px] text-base sm:text-[18px] md:text-[20px] lg:text-[22px] leading-[165%] text-white/95">
                {courseDetailsData?.course?.courseEntrollDescription}
              </p>

              {/* PRICE CARD + ROCKET */}
              <div className="relative mt-6">
                {/* Rocket - responsive sizing */}
                <img
                  src={rocketImage}
                  alt=""
                  className="
            absolute
            right-0
            top-[-50px] sm:top-[-60px] md:top-[-70px]
            w-[150px] sm:w-[200px] md:w-[240px] lg:w-[390px]
            object-contain
            z-20
            pointer-events-none
          "
                />

                {/* Card - fully responsive */}
                <div
                  className="
            inline-flex
            flex-col
            sm:flex-row
            border
            border-white/40
            rounded-[20px]
            overflow-hidden
            bg-[#000D36]/25
            backdrop-blur-sm
            relative
            z-10
            w-full
            sm:w-auto
          "
                >
                  {/* Left */}
                  <div className="px-4 sm:px-6 md:px-8 py-5 sm:py-6 md:py-7 w-full sm:w-auto">
                    <h3 className="text-xl sm:text-[22px] md:text-[24px] font-semibold text-white/90">
                      Program Value
                    </h3>
                    <div className="mt-3 sm:mt-4 flex flex-wrap items-center gap-2 sm:gap-3">
                      <span className="text-[#FF5A00] text-3xl sm:text-[40px] md:text-[48px] font-bold line-through">
                        ₹1,00,000
                      </span>
                      <span className="bg-[#1557FF] px-2 sm:px-3 py-1 rounded text-xs sm:text-sm font-semibold">
                        +GST
                      </span>
                    </div>
                  </div>

                  {/* Divider - responsive */}
                  <div className="w-full sm:w-[3px] h-[3px] sm:h-auto bg-[#FF5A00]" />

                  {/* Right */}
                  <div className="px-4 sm:px-6 md:px-8 py-5 sm:py-6 md:py-7 w-full sm:w-auto">
                    <h3 className="text-xl sm:text-[22px] md:text-[24px] font-semibold text-white/90">
                      Today Only
                    </h3>
                    <div className="mt-3 sm:mt-4 flex flex-wrap items-center gap-2 sm:gap-3">
                      <span className="text-[#FF5A00] text-3xl sm:text-[40px] md:text-[48px] font-bold">
                        ₹{formatIndianPrice(displayPrice)}/-
                      </span>
                      <span className="bg-[#1557FF] px-2 sm:px-3 py-1 rounded text-xs sm:text-sm font-semibold">
                        +GST
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* ENROLL + WATCH */}
              <div className="flex flex-col lg:flex-row lg:items-center gap-6 sm:gap-8 lg:gap-10 mt-6 sm:mt-8 lg:mt-4">
                {/* Enroll / Go to Course */}
                <div className="w-full sm:w-auto">
                  {purchasedCourseId ? (
                    <div className="relative inline-flex p-3 border-2 border-dashed border-white/70 rounded-md w-full sm:w-auto">
                      <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            `/courses/Courses/CourseDetails/CoursesVideos/${id}`
                          )
                        }
                        className="
                  w-full sm:w-auto
                  h-[56px] sm:h-[66px] md:h-[76px]
                  px-6 sm:px-8 md:px-12
                  bg-[#FC3602]
                  hover:bg-[#e43100]
                  text-white
                  text-xl sm:text-2xl md:text-[28px]
                  font-bold
                  uppercase
                  rounded-[8px]
                  transition
                "
                      >
                        GO TO COURSE
                      </button>
                      <span className="absolute -right-6 -bottom-7 sm:-right-7 sm:-bottom-8">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden
                        >
                          <path
                            d="M3 2L21 10L13 13L10 21L3 2Z"
                            fill="#FC3602"
                            stroke="#FC3602"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  ) : (
                    <div className="relative inline-flex p-3 border-2 border-dashed border-white/70 rounded-md w-full sm:w-auto">
                      <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                      <button
                        type="button"
                        onClick={() => {
                          setShowPaymentPopup(true);
                          if (!isAuthenticated) {
                            setPendingPaymentAction(true);
                          }
                        }}
                        className="
                  w-full sm:w-auto
                  h-[56px] sm:h-[66px] md:h-[76px]
                  px-6 sm:px-8 md:px-12
                  bg-[#FC3602]
                  hover:bg-[#e43100]
                  text-white
                  text-xl sm:text-2xl md:text-[28px]
                  font-bold
                  uppercase
                  rounded-[8px]
                  transition
                "
                      >
                        ENROLL NOW
                      </button>
                      <span className="absolute -right-6 -bottom-7 sm:-right-7 sm:-bottom-8">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden
                        >
                          <path
                            d="M3 2L21 10L13 13L10 21L3 2Z"
                            fill="#FC3602"
                            stroke="#FC3602"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  )}
                </div>

                {/* Watch Trailer - Play button inline with description text */}
                {hasEnrollTrailer && (
                  <button
                    type="button"
                    onClick={handleWatchMasterclass}
                    className="flex flex-col items-start text-center sm:text-left group w-full sm:w-auto"
                  >
                    <h3
                      className="
                text-[#FF5A00]
                text-lg sm:text-xl md:text-[26px]
                font-bold
                uppercase
                leading-tight
              "
                    >
                      WATCH FREE MASTERCLASS NOW
                    </h3>
                    <div className="flex flex-row items-center gap-3 sm:gap-5">
                      <p
                        className="
                  max-w-[340px]
                  text-sm sm:text-base md:text-[18px]
                  leading-relaxed
                  text-white/90
                "
                      >
                        Master the art of online business with this immersive Training
                        program.
                      </p>
                      <span
                        className="
                  flex
                  h-[44px] sm:h-[50px] md:h-[54px]
                  w-[44px] sm:w-[50px] md:w-[54px]
                  items-center
                  justify-center
                  rounded-full
                  border-2
                  border-[#FF5A00]
                  flex-shrink-0
                "
                      >
                        <img
                          src="/assets/icons/play.svg"
                          alt=""
                          className="w-4 h-4 sm:w-5 sm:h-5"
                        />
                      </span>
                    </div>
                  </button>
                )}
              </div>

              {/* BEST SUITED - Centered on mobile */}
              {courseDetailsData?.course?.bestSuitFor?.length > 0 && (
                <div className="mt-8 sm:mt-10 text-center sm:text-left">
                  <p className="text-white/80 text-sm sm:text-base mb-3 sm:mb-4">
                    Best suited for ➜
                  </p>
                  <div className="flex flex-wrap gap-3 sm:gap-4 justify-center sm:justify-start">
                    {courseDetailsData.course.bestSuitFor.map((item, index) => (
                      <span
                        key={index}
                        className="
                  px-4 sm:px-6 md:px-7
                  h-10 sm:h-11 md:h-12
                  rounded-full
                  bg-black
                  border-2
                  border-[grey]
                  flex
                  items-center
                  justify-center
                  text-white
                  text-xs sm:text-sm
                  font-medium
                  whitespace-nowrap
                "
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Webinar Details */}
        {courseDetailsData?.relatedWebinars && (
          <div className="px-[6%] max-w-[1500px] w-full mx-auto">
            <div
              className="relative flex justify-center p-5 w-full min-h-[80vh] mt-8 rounded-lg"
              style={{
                backgroundImage: `
                  linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 5%, rgba(0, 0, 0, 0.8) 67%),
                  url(${courseDetailsData?.relatedWebinars
                    ?.certificateBannerImage?.[0] || enrollCourseImage
                  })`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="flex flex-col items-center w-full text-white">
                {courseDetailsData?.relatedWebinars?.courseEntrollLogo?.[0] ? (
                  <img
                    src={
                      courseDetailsData?.relatedWebinars?.courseEntrollLogo[0]
                    }
                    alt="logo"
                    className="w-[150px] h-[80px] object-contain"
                  />
                ) : (
                  <KingsterLogo />
                )}

                <div className="w-[70%] mt-5 text-center p-5">
                  {courseDetailsData?.relatedWebinars?.webinarDescription ||
                    "Join our upcoming webinar"}
                </div>

                <div className="underline text-center">
                  Free webinar :{" "}
                  {formatWebinarDateTime(
                    courseDetailsData?.relatedWebinars?.webinarDate,
                    courseDetailsData?.relatedWebinars?.webinarStartTime,
                  )}
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="flex items-center justify-center gap-1 px-4 py-3 text-white bg-blue-500 rounded-full h-14 min-w-[200px]"
                    onClick={() => {
                      if (courseDetailsData?.relatedWebinars?.ZoomURL) {
                        window.open(
                          courseDetailsData?.relatedWebinars?.ZoomURL,
                          "_blank",
                        );
                      } else {
                        Toastify.warning("Webinar link not available yet");
                      }
                    }}
                  >
                    <FormSubMissionButton />
                    Join this webinar
                  </button>
                </div>

                <div className="mt-8 text-lg text-gray-400 whitespace-nowrap">
                  Best suited for
                </div>

                <div className="flex flex-wrap justify-center gap-3 mt-3">
                  {courseDetailsData?.relatedWebinars?.bestSuitFor?.map(
                    (item, index) => (
                      <div
                        key={index}
                        className="px-5 py-2 text-sm font-bold text-center text-gray-600 bg-white rounded-full whitespace-nowrap"
                      >
                        {item}
                      </div>
                    ),
                  ) || (
                      <div className="px-5 py-2 text-sm font-bold text-center text-gray-600 bg-white rounded-full whitespace-nowrap">
                        All learners
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <HowToApply /> */}
        <div className="flex flex-col gap-0">
          <LearningMethod />

          {/* Certificate */}
          {/* Certificate of Achievement Section */}
          <div className="max-w-[1500px] h-[500px] md:h-[900px] w-full mx-auto">
            <div
              className="relative flex flex-col justify-center items-center p-5 w-full h-full"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 0%), url(${certificateCourseImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              {/* Centered Title & Description */}
              <div className="flex flex-col items-center text-white text-center mt-[-210px] md:mt-0">
                <div className="text-[32px] sm:text-[40px] md:text-5xl font-bold font-[Figtree] leading-tight">
                  Certificate of Achievement
                </div>

                <div className="w-full md:w-[60%] text-sm font-normal leading-5 mt-3 sm:mt-4 md:mt-6 px-4 md:px-0">
                  Completing your journey with Kingster Education transcends
                  beyond the final course assessment; it's an occasion to be
                  bestowed with a mark of distinction.
                </div>
              </div>

              {/* Bottom Strip */}
              <div className="absolute bottom-3 md:bottom-5 w-full md:w-[70%] mx-auto px-4 md:px-0">
                <div className="flex flex-col md:flex-row items-center justify-between p-4 md:p-3 bg-white/80 rounded-2xl md:rounded-full shadow border border-gray-100 gap-4 md:gap-0">
                  <div className="flex flex-col md:flex-row items-center gap-3 md:gap-5 w-full md:w-auto">
                    <div className="flex -space-x-3">
                      {[3, 4, 5, 6].map((num) => (
                        <img
                          key={num}
                          src={`/Image${num}.png`}
                          alt={`User ${num - 2}`}
                          className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white shadow-md"
                        />
                      ))}
                    </div>
                    <div className="max-w-full text-center md:text-left py-2">
                      <h3 className="text-base lg:text-start text-center md:text-lg font-bold text-gray-800">
                        10,000+ Business owners
                      </h3>
                      <p className="text-xs md:text-sm font-medium text-gray-600">
                        Join a community of learners dedicated to achieving career
                        success and personal growth.
                      </p>
                    </div>
                  </div>

                  {/* Styled Button - Enroll Now / Go to Course */}
                  {purchasedCourseId ? (
                    <button
                      className="flex items-center gap-[10px] px-6 py-3 md:px-4 md:py-2 rounded-[100px] border border-[#D8D8D8] shadow-sm hover:scale-[1.03] transition-all duration-300 text-white"
                      style={{
                        background: "linear-gradient(94.44deg, #1D83F8 1.62%, #114D92 78.57%)",
                      }}
                      onClick={() => {
                        // Navigate to course or handle purchase flow
                        navigate(
                          `/courses/Courses/CourseDetails/CoursesVideos/${id}`,
                          {
                            state: { courseDetailsData },
                          }
                        );
                      }}
                    >
                      <div className="w-[40px] h-[40px] md:w-[36px] md:h-[36px] rounded-full bg-white flex items-center justify-center shrink-0">
                        <svg
                          className="w-5 h-5 md:w-4 md:h-4"
                          style={{
                            filter: "brightness(0) saturate(100%) invert(27%) sepia(89%) saturate(1901%) hue-rotate(202deg) brightness(93%) contrast(97%)"
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </div>
                      <span className="font-[Figtree] font-medium text-[20px] md:text-[18px] leading-[150%] text-white">
                        Go to Course
                      </span>
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="flex items-center gap-[10px] px-6 py-3 md:px-4 md:py-2 rounded-[100px] border border-[#D8D8D8] shadow-sm hover:scale-[1.03] transition-all duration-300 text-white"
                      style={{
                        background: "linear-gradient(94.44deg, #1D83F8 1.62%, #114D92 78.57%)",
                      }}
                      onClick={() => {
                        // Show payment popup or navigate to payment
                        setShowPaymentPopup(true);
                        if (!isAuthenticated) {
                          setPendingPaymentAction(true);
                        }
                      }}
                    >
                      <div className="w-[40px] h-[40px] md:w-[36px] md:h-[36px] rounded-full bg-white flex items-center justify-center shrink-0">
                        <svg
                          className="w-5 h-5 md:w-4 md:h-4"
                          style={{
                            filter: "brightness(0) saturate(100%) invert(27%) sepia(89%) saturate(1901%) hue-rotate(202deg) brightness(93%) contrast(97%)"
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                      </div>
                      <span className="font-[Figtree] font-medium text-[20px] md:text-[18px] leading-[150%] text-white">
                        Enroll Now
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <SupportSection
          onViewFaqClick={scrollToFaq}
          onRequestCallBackClick={scrollToEnquireForm}
          onChatWithUsClick={openChat} // Add this line
        />

        {/* Projects & Assessments */}
        <div className="px-4 sm:px-6 lg:px-[60px] max-w-[1400px] w-full mx-auto">
          <div className="py-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            {/* Left: Heading */}
            <h2
              className="
    font-[Figtree]
    font-semibold

    text-[34px]
    sm:text-[42px]
    lg:text-[55px]

    leading-[150%]

    tracking-[-0.03em]

    text-center

    text-[#02054C]

    mb-12
  "
            >
              Projects & Assessments
            </h2>

            {/* Right: Description */}
            <div className="w-full lg:w-[60%] text-base sm:text-lg font-medium leading-6 sm:leading-7 text-gray-500">
              {courseDetailsData?.course?.projectAndAssignmentDescription}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10 py-6 sm:py-8">
            {courseDetailsData?.course?.projectAndAssignment?.map(
              (item, index) => (
                <div
                  key={index}
                  className="h-[600px] rounded-2xl bg-white shadow-[1px_2px_64px_0px_rgba(0,0,0,0.18)] overflow-hidden flex flex-col"
                >
                  {/* Fixed-height text section */}
                  <div className="p-4 sm:p-5 h-[330px] flex flex-col justify-center">
                    <div className="text-xl sm:text-2xl lg:text-3xl font-bold leading-6 sm:leading-8 px-4 pt-8 text-gray-900 pb-2">
                      {item?.title}
                    </div>
                    <div className="text-sm sm:text-base lg:text-lg font-medium leading-5 sm:leading-6 px-4 pb-8 text-gray-500">
                      {item?.subTitle}
                    </div>
                  </div>

                  {/* Image fills remaining height */}
                  <div className="flex-1">
                    <img
                      src={item?.img[0]}
                      alt={item?.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              ),
            )}
          </div>
        </div>

        {/* Follow Us Section */}
        {/* Follow Us Section */}
        <div className="w-full mx-auto my-8 sm:my-12 lg:my-16">
          <div
            className="relative overflow-hidden rounded-none"
            style={{
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Content */}
            <div className="relative z-10 py-12 sm:py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 text-center text-white">
              {/* Heading */}
              <h2
                className="
      font-[Figtree]
      font-semibold
      text-[28px]
      sm:text-[36px]
      md:text-[42px]
      lg:text-[50px]
      xl:text-[64px]
      leading-[110%]
      tracking-[-0.04em]
      max-w-[950px]
      mx-auto
    "
              >
                Your Next Big Opportunity Starts Here
              </h2>

              {/* New text below heading */}
              <p
                className="
      mt-3
      max-w-[760px]
      mx-auto
      text-[16px]
      sm:text-[18px]
      md:text-[20px]
      font-medium
      leading-[140%]
      text-white/95
    "
              >
                Join Kingster's FREE 20-Minute Masterclass and explore practical
                learning pathways designed for real-world success.
              </p>

              {/* Button */}
              <div className="relative inline-flex p-3 border-2 border-dashed border-white/70 rounded-md w-full sm:w-auto mt-8 sm:mt-9 md:mt-10">
                <span className="absolute -top-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                <span className="absolute -top-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                <span className="absolute -bottom-2 -left-2 h-3.5 w-3.5 rounded-full bg-white" />
                <span className="absolute -bottom-2 -right-2 h-3.5 w-3.5 rounded-full bg-white" />
                <button
                  onClick={handleWatchMasterclass}
                  className="
            h-[56px] sm:h-[60px] md:h-[65px] lg:h-[70px]
            px-6 sm:px-8 md:px-10 lg:px-12
            bg-[#FC3602]
            hover:bg-[#e43100]
            text-white
            text-base sm:text-[18px] md:text-[20px] lg:text-[22px]
            font-bold
            uppercase
            transition
            rounded-[8px]
            w-full
            sm:w-auto
            min-w-[200px]
          "
                >
                  WATCH FREE MASTERCLASS
                </button>
                <span className="absolute -right-6 -bottom-7 sm:-right-7 sm:-bottom-8">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                  >
                    <path
                      d="M3 2L21 10L13 13L10 21L3 2Z"
                      fill="#FC3602"
                      stroke="#FC3602"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>

              {/* Bottom Text */}
              <p
                className="
      mt-4 sm:mt-5
      text-sm sm:text-base md:text-[18px]
      text-white/80
    "
              >
                *Limited Seats Available
              </p>
            </div>
          </div>
        </div>
        {/* FAQ Section */}
        <div
          ref={faqSectionRef}
          className="px-4 max-w-[1500px] w-full mx-auto"
        >
          {/* Centered Heading */}
          <h2
            className="font-[Figtree] font-semibold text-[34px] sm:text-[42px] lg:text-[55px] leading-[150%] tracking-[-0.03em] text-center text-[#02054C]"
          >
            Frequently Asked Questions
          </h2>

          {/* Centered Contact Info */}
          <div className="text-center mt-4">
            <p className="text-sm md:text-base text-gray-800">
              Still you have any questions? Contact our Team via support@kingsteredu.com
            </p>
            <button
              className="inline-flex items-center gap-1 px-4 py-2 mt-4 text-sm font-semibold bg-gray-100 rounded-full border border-gray-200 hover:bg-gray-200 transition-colors"
              onClick={() => {
                document
                  .getElementById("enquire-now-form")
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              <GetInTouch /> Ask A Question
            </button>
          </div>

          {/* FAQ List - Centered with 50% width */}
          <div className="mt-8 flex justify-center">
            <div className="w-full md:w-[60%]">
              <FaqList courseDetailsData={courseDetailsData?.course?.faq} />
            </div>
          </div>
        </div>
      </div>
      {hasEnrollTrailer && (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 flex justify-center px-[14px] pb-4">
          <button
            type="button"
            onClick={handleWatchMasterclass}
            className="w-[250px] max-w-full h-[58px] rounded-[100px] py-4 px-6 text-white text-base font-bold uppercase tracking-wide shadow-[0_4px_20px_rgba(189,40,0,0.35)]"
            style={{
              background: "linear-gradient(90deg, #FF3600 0%, #BD2800 100%)",
            }}
          >
            Watch Masterclass
          </button>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};

export default CourseDetailsPage;
